import { render } from "./AdvanceTab.vue?vue&type=template&id=1c928018&scoped=true"
import script from "./AdvanceTab.vue?vue&type=script&lang=js"
export * from "./AdvanceTab.vue?vue&type=script&lang=js"

import "./AdvanceTab.vue?vue&type=style&index=0&id=1c928018&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c928018"]])

export default __exports__